import { apiUrl, getLocalToken } from "../../apiClient";
import { getLoggedInUser } from "../../helper";
import { endpoint } from "../endpoint";
const { createApi, fetchBaseQuery } = require("@reduxjs/toolkit/query/react");

export const officer_api = createApi({
  reducerPath: "officer",
  baseQuery: fetchBaseQuery({
    baseUrl: `${apiUrl}/api`,
    prepareHeaders: (headers) => {
      let token = getLocalToken();
      if (token) {
        headers.set("Authorization", token);
      }
      headers.set = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
      return headers;
    },
  }),
  endpoints: (builder) => ({
    // const user = LocalStorage.getItem("tata_login_user")?.roles;
    edit_vendor: builder.mutation({
      query: (data) => ({
        url: getLoggedInUser().roles.includes("officer")
          ? `${endpoint.officer}/edit-vendor`
          : `${endpoint.admin_vendor}/edit-vendor`,
        method: "POST",
        body: data,
        headers: {
          Authorization: getLocalToken(),
        },
      }),
    }),
  }),
});

export const { useEdit_vendorMutation } = officer_api;
